import { CommonModule } from '@angular/common';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { OpenItemModalModule } from 'NewAngular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { InfoFieldSelectorModalModule } from 'SecuritiesApp/ts/info-field-selector-modals/info-field-selector-modal.module';
import * as i0 from "@angular/core";
export class EditDataColumnsModalModule {
}
EditDataColumnsModalModule.ɵfac = function EditDataColumnsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditDataColumnsModalModule)(); };
EditDataColumnsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EditDataColumnsModalModule });
EditDataColumnsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        InfoFieldSelectorModalModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        IconModule,
        TooltipModule,
        OpenItemModalModule] });
